<div class="d-flex align-items-center main-tabs b-b-tabs" *ngIf="isLead">
  <ul class="nav tools-tab-nav {{ mobToggle ? 'w-85' : '' }}" role="tablist">
    <li *ngFor="let item of menuItems.lead">
      <ng-container *ngFlag="item.flag">
        <ng-container *ngxPermissionsOnly="item.permissions">
          <a routerLinkActive="active" [routerLink]="item.routerLink" [routerLinkActiveOptions]="{ exact: item.exact }">
            <img [src]="item.icon" class="mr-2" [width]="item.width" />
            <p>{{ item.label }}</p>
          </a>
        </ng-container>
      </ng-container>
    </li>
  </ul>
</div>

<div class="d-flex align-items-center main-tabs b-b-tabs" *ngIf="isTask">
  <ul class="nav tools-tab-nav {{ mobToggle ? 'w-85' : '' }}" role="tablist">
    <li *ngFor="let item of menuItems.task">
      <ng-container *ngFlag="item.flag">
        <ng-container *ngxPermissionsOnly="item.permissions">
          <a routerLinkActive="active" [routerLink]="item.routerLink">
            <img [src]="item.icon" class="mr-2" [width]="item.width" />
            <p>{{ item.label }}</p>
          </a>
        </ng-container>
      </ng-container>
    </li>
  </ul>
</div>

<div class="d-flex align-items-center main-tabs b-b-tabs overflow-auto" *ngIf="isSetting">
  <ul class="nav tools-tab-nav {{ mobToggle ? 'w-85' : '' }}" role="tablist" [style.margin-left]="margin">
    <li *ngFor="let item of menuItems.setting">
      <ng-container *ngFlag="item.flag">
        <ng-container *ngxPermissionsOnly="item.permissions">
          <a routerLinkActive="active" [routerLink]="item.routerLink">
            <img [src]="item.icon" class="mr-2" [width]="item.width" />
            <p>{{ item.label }}</p>
          </a>
        </ng-container>
      </ng-container>
    </li>
  </ul>
</div>

<div class="d-flex align-items-center main-tabs b-b-tabs" *ngIf="isProject">
  <ul class="nav tools-tab-nav {{ mobToggle ? 'w-85' : '' }}" role="tablist">
    <li *ngFor="let item of menuItems.project">
      <ng-container *ngFlag="item.flag">
        <ng-container *ngxPermissionsOnly="item.permissions">
          <a routerLinkActive="active" (click)="loadProject()" [routerLink]="item.routerLink">
            <img [src]="item.icon" class="mr-2" [width]="item.width" />
            <p>{{ item.label }}</p>
          </a>
        </ng-container>
      </ng-container>
    </li>
  </ul>
</div>

<div class="d-flex align-items-center main-tabs b-b-tabs" *ngIf="isSale">
  <ul class="nav tools-tab-nav {{ mobToggle ? 'w-85' : '' }}" role="tablist">
    <li *ngFor="let item of menuItems.sale">
      <ng-container *ngIf="isItemAllowed(item)">
        <ng-container *ngFlag="item.flag">
          <ng-container *ngxPermissionsOnly="item.permissions">
            <a routerLinkActive="active" [routerLink]="item.routerLink">
              <img [src]="item.icon" class="mr-2" [width]="item.width" />
              <p>{{ item.label }}</p>
            </a>
          </ng-container>
        </ng-container>
      </ng-container>
    </li>
  </ul>
</div>

<div class="d-flex align-items-center main-tabs b-b-tabs" *ngIf="isListing || isProperty || isApproval || (!fromLead && isOfi)">
  <ul class="nav tools-tab-nav {{ mobToggle ? 'w-85' : '' }}" role="tablist">
    <li *ngFor="let item of menuItems.listing">
      <ng-container *ngFlag="item.flag">
        <a routerLinkActive="active" [routerLink]="item.routerLink">
          <ng-container *ngIf="item.img; else no_listingImg">
            <img [src]="item.img" class="mr-2" [width]="item.width" />
          </ng-container>
          <ng-template #no_listingImg>
            <i class="{{ item.icon }}"></i>
          </ng-template>
          <p>{{ item.label }}</p>
        </a></ng-container
      >
    </li>
  </ul>
</div>

<!-- Remmi Releases: the module is resolved from the URL, so this one placement serves every page using this menu. -->
<app-feature-release-banner class="d-block mt-2" *ngIf="showReleaseBanner"></app-feature-release-banner>
